<template>
  <section class="cert-home">
    <div class="cert-home-header">
      <div>
        <span>Emissão autenticada</span>
        <h1>Gerar certificados</h1>
        <p>
          Emita certificados individuais ou em lote com rastreabilidade, QR
          Code, assinatura digital PAdES/LT e validação no ITI.
        </p>
      </div>

      <!-- <div class="cert-home-badges">
        <strong>DSS/PAdES LT</strong>
        <small>ITI validado</small>
      </div> -->
    </div>

    <div class="cert-home-form">
      <FormBase />
    </div>
  </section>
</template>

<script setup>
import FormBase from "./FormBase.vue";
</script>

<style scoped>
.cert-home {
  max-width: 1180px;
  margin: 0 auto;
}

.cert-home-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 1.4rem;
  padding: 1.65rem 1.85rem;
  border-radius: 28px;
  background: radial-gradient(
      circle at top right,
      rgba(255, 148, 23, 0.18),
      transparent 22rem
    ),
    rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.1);
}

.cert-home-header span {
  color: #f97316;
  font-size: 0.72rem;
  font-family: "XoloniumBold", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.cert-home-header h1 {
  margin: 0.45rem 0;
  color: #0f172a;
  font-size: clamp(1.85rem, 3.2vw, 2.65rem);
  line-height: 0.98;
  font-family: "XoloniumBold", sans-serif;
  letter-spacing: -0.045em;
}

.cert-home-header p {
  max-width: 780px;
  color: #64748b;
  line-height: 1.75;
}

.cert-home-badges {
  min-width: 170px;
  padding: 1rem;
  border-radius: 24px;
  color: #111827;
  background: linear-gradient(135deg, #ffb020, #ff7300);
  box-shadow: 0 16px 36px rgba(255, 115, 0, 0.22);
}

.cert-home-badges strong,
.cert-home-badges small {
  display: block;
}

.cert-home-badges strong {
  font-family: "XoloniumBold", sans-serif;
}

.cert-home-badges small {
  margin-top: 0.3rem;
  color: rgba(17, 24, 39, 0.72);
}

.cert-home-form {
  padding: 1.6rem;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.84);
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.1);
}

@media (max-width: 900px) {
  .cert-home-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.35rem;
  }

  .cert-home-form {
    padding: 1rem;
  }
}
</style>
